module.exports = __webpack_public_path__ + "static/media/355799279717459570466615420087363375618.07776c89.png";